import React, { useState, useEffect } from 'react';
import HorizontalTabRSA from '../HorizontalTabRSA';
import EmbankmentTabRSA from '../EmbankmentRSA/EmbankmentRSA';
import AutomaticReportsTab from '../AutomaticReports.jsx';
import './TabsRSA.css';

export default function TabsRSA({ services = [], lidarType, onSaveMap = {} }) {
  // Define all possible RSA tabs (now includes Automatic Reports)
  const ALL_TABS = [
    { id: 'horizontal', label: 'Horizontal', Component: HorizontalTabRSA },
    { id: 'embankment', label: 'Embankment', Component: EmbankmentTabRSA },
    { id: 'automatic_reports', label: 'Automatic Reports', Component: AutomaticReportsTab },
  ];

  // Only keep tabs the user has selected
  const tabs = ALL_TABS.filter(tab => services.includes(tab.id));

  // Track the active tab
  const [activeTab, setActiveTab] = useState(tabs[0]?.id || '');

  // Reset activeTab if tabs change
  useEffect(() => {
    if (tabs.length > 0) {
      setActiveTab(prev => tabs.find(t => t.id === prev)?.id || tabs[0].id);
    }
  }, [tabs]);

  // If no relevant services, render nothing
  if (tabs.length === 0) return null;

  return (
    <div className="tabs w35">
      {/* Tab list */}
      <div className="tab-list">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={tab.id === activeTab ? 'tab-btn active' : 'tab-btn'}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab panels: keep all mounted, hide inactive to preserve state */}
      <div className="tab-content sidewindow">
        {tabs.map(tab => (
          <div
            key={tab.id}
            style={{ display: tab.id === activeTab ? 'block' : 'none' }}
          >
            {/* Pass lidarType along so EmbankmentTabRSA can use it. */}
            {/* We also pass onSave; components that don't use it will simply ignore the prop. */}
            <tab.Component
              onSave={onSaveMap[tab.id]}
              lidarType={lidarType}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
